import { createFileRoute, redirect } from "@tanstack/react-router";
import { MEMBERSHIP_JOURNEY_PATH } from "@/lib/funnel";

/**
 * The one-time 14-Day Recovery Pass is no longer offered. Anyone landing here
 * (old link, bookmark, search result) goes straight to the membership journey.
 */
export const Route = createFileRoute("/checkout/pass")({
  beforeLoad: () => {
    throw redirect({ to: MEMBERSHIP_JOURNEY_PATH });
  },
  component: () => null,
});
